<script setup lang="ts">
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useCurrentUser } from 'vuefire';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();
const user = useCurrentUser();
const errorMessage = ref<string>("");

// User not signed in.
if (user?.value) {
  authStore.signout()
    .catch(error => {
      errorMessage.value = error.message ?? error;
    });
}

const handleSigninButton = (event: Event) => {
  event.preventDefault();
  // base64 encode the redirection path to preserve query params
  router.push({
    name: 'signin',
    query: { redirect: route.query.redirect as string || "/" }
  });
};

</script>

<template>
  <div class="card mx-auto">
    <div class="card-body">
      <h1 class="card-title">
        Bye for now
      </h1>
      <div v-if="errorMessage != ''" class="error-message">
        {{ errorMessage }}
      </div>
      <div v-if="!errorMessage">
        <p>You have been signed out.</p>
        <button id="signin" @click="handleSigninButton">
          Sign in again
        </button>
      </div>
    </div>
  </div>
</template>
